// extracted by mini-css-extract-plugin
export default {"location":"Pagehead_location__9USTS"};